import { Component } from "@basic-orange/component";
import { getCookie } from '../../../src/js/functions';

export default class headervisual extends Component {
	constructor(elm, componentId) {
		super(elm, componentId);

		this.$elm = $(elm);
		this.$sliderContainer = this.$elm.find('.slider');
		this.$clusterElm = this.$elm.find('.slick-counter');

		this.breakpointLarge = 1024;
		this.breakpointXLarge = 1920;
		this.hasConsent = false;

		this.$videoContainers = this.$elm.find('.video-container');
		this.hasYoutubeVideos = this.$videoContainers.length > 0;

		this.loadScriptInterval = null;
		this.init();
	}

	//Logic
	async init() {
		const consentCookie = await getCookie('occ');
		const cookieConsent = consentCookie.split(',');
		this.hasConsent = cookieConsent.includes('allcookies') || cookieConsent.includes('Media') || cookieConsent.includes('Video');

		if (this.hasYoutubeVideos && this.hasConsent) {
			if (!window.YT) {
				this.loadScriptAndUInitYoutubeSlides();
			} else {
				this.initYoutubeSlides();
			}
		}

		cookieStore.addEventListener('change', async ({ changed, deleted }) => {
			const occChanged = changed.find(c => c.name === 'occ');
			const occDeleted = deleted.find(c => c.name === 'occ');

			if (occChanged || occDeleted) {
				const cookieValue = occChanged?.value || '';
				const cookieConsent = cookieValue.split(',');

				this.hasConsent = cookieConsent.includes('allcookies') || cookieConsent.includes('Media') || cookieConsent.includes('Video');

				if (this.hasYoutubeVideos) {
					if (this.hasConsent) {
						if (!window.YT) {
							this.loadScriptAndUInitYoutubeSlides();
						} else {
							this.initYoutubeSlides();
						}
					} else {
						window.location.reload();
					}
				}

				this.$sliderContainer.slick('reinit');
			}
		});
		this.$sliderContainer.on('init reInit', function (event, slick, currentSlide, nextSlide) {
			//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
			var i = (currentSlide ? currentSlide : 0) + 1;
			this.$clusterElm.text(i + '/' + slick.slideCount);
			if (slick.$slides.length === 1) {
				this.$clusterElm.remove();
			}
			var timer = setTimeout(function () {
				if ($('iframe', slick.$slides[0]).length) {
					var data = { "event": "command", "func": "playVideo", "args": "" };
					var message = JSON.stringify(data);
					$('iframe', slick.$slides[currentSlide])[0].contentWindow.postMessage(message, '*');
					$(slick.$slides[0]).find('.video-container').addClass('is-playing');
					$(slick.$slides[0]).find('.Slider-pauseButton').addClass('is-active');
				}
				clearTimeout(timer);
			}, 500);
		}.bind(this));

		this.$sliderContainer.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			$(slick.$slides).each(function () {
				var $this = $(this);
				var $iframe = $this.find('iframe');
				if ($iframe.length) {
					var data = { "event": "command", "func": "pauseVideo", "args": "" };
					var message = JSON.stringify(data);
					$iframe[0].contentWindow.postMessage(message, '*');
					$this.find('.video-container').removeClass('is-playing');
					$this.find('.Slider-pauseButton').removeClass('is-active');
				}
			});
		});

		this.$sliderContainer.on('afterChange', function (event, slick, currentSlide, nextSlide) {
			var $iframe = $('iframe', slick.$slides[currentSlide]);
			if ($iframe.length) {
				var data = { "event": "command", "func": "playVideo", "args": "" };
				var message = JSON.stringify(data);
				$iframe[0].contentWindow.postMessage(message, '*');
				$(slick.$slides[currentSlide]).find('.video-container').addClass('is-playing');
                $(slick.$slides[currentSlide]).find('.Slider-pauseButton').addClass('is-active');
			}
			var i = (currentSlide ? currentSlide : 0) + 1;
			this.$clusterElm.text(i + '/' + slick.slideCount);
		}.bind(this));

		this.$sliderContainer.slick({
			arrows: true,
			prevArrow: '<span class="slick-arrow-prev"><i class="fa fa-chevron-left"></i></span>',
			nextArrow: '<span class="slick-arrow-next"><i class="fa fa-chevron-right"></i></span>',
			vertical: false,
			autoplay: false,
			draggable: false,
			mobileFirst: true,
			adaptiveHeight: false,
			dots: false,
			infinite: false,
			speed: 1500,
			slidesToShow: 1,
			slidesToScroll: 1,
            rtl: $('body').hasClass('rtl')
		});

		$(window).resize(function () {
			this.$sliderContainer.slick('resize');
		}.bind(this));
	}

	loadScriptAndUInitYoutubeSlides() {
		this.loadYoutubeScript();

		this.loadScriptInterval = setInterval(() => {
			if (window.YT && window.YT.loaded) {
				clearInterval(this.loadScriptInterval);

				this.initYoutubeSlides();
			}
		}, 100);
	}

	loadYoutubeScript() {
		var tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	initYoutubeSlides() {
		this.$videoContainers.each(
			function (i, elm) {
				var $elm = $(elm);
				var $button = $elm.find('.Slider-pauseButton');
				var $caption = $elm.find('.warning-caption');
				var videoid = $elm.data('youtubevideoid');
				var ytContainerId = `player_${this.componentId}_${i}`;
				$button.addClass('active');
				$caption.removeClass('active');
				$elm.append(`<div id="${ytContainerId}"></div>`);

				var player = new YT.Player(ytContainerId, {
					width: 'auto',
					height: 'auto',
					videoId: videoid,
					host: 'https://www.youtube-nocookie.com',
					playerVars: {
						playsinline: 1,
						autoplay: 0,
						mute: 1,
						controls: 0,
						loop: 1,
						playlist: videoid,
						rel: 0,
						modestbranding: 0
					},
					events: {
						onStateChange: (event) => {
							if (event.data === YT.PlayerState.ENDED) {
								event.target.seekTo(0);
								event.target.playVideo();
							}
						},
					},
				});

				$button.on('click', function () {
					if ($button.hasClass('is-active')) {
						player.pauseVideo();
						$button.removeClass('is-active');
						$elm.removeClass('is-playing');
					} else {
						player.playVideo();
						$button.addClass('is-active');
						$elm.addClass('is-playing');
					}
				});

				var current = this.$sliderContainer.find('.slick-current iframe');
				if (current.length) {
					var data = { "event": "command", "func": "playVideo", "args": "" };
					var message = JSON.stringify(data);
					window.setTimeout(function () {
						current[0].contentWindow.postMessage(message, '*');
						current.parent().addClass('is-playing');
						current.parent().find('.Slider-pauseButton').addClass('is-active');
					}, 500);
				}

			}.bind(this)
		);
	}
}
